// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-42a33cdb]{fill:var(--green)}.check[data-v-42a33cdb]{stroke-dasharray:1000;stroke-dashoffset:1000;animation:dash-data-v-42a33cdb 1.3s linear .5s forwards}@keyframes dash-data-v-42a33cdb{to{stroke-dashoffset:0}}", ""]);
// Exports
module.exports = exports;
